var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.8554 6.56639C18.1172 6.56533 17.4096 6.27516 16.8878 5.75953C16.3659 5.24389 16.0725 4.54488 16.0718 3.81584V0H3.63284C2.66935 0 1.74534 0.377999 1.06405 1.05085C0.382756 1.7237 0 2.6363 0 3.58786V25.2163C0 26.1678 0.382756 27.0804 1.06405 27.7533C1.74534 28.4261 2.66935 28.8041 3.63284 28.8041H18.5638C19.041 28.8043 19.5136 28.7116 19.9545 28.5314C20.3954 28.3512 20.796 28.0869 21.1335 27.7537C21.471 27.4206 21.7387 27.025 21.9214 26.5896C22.104 26.1542 22.198 25.6876 22.198 25.2163V6.56639H18.8554Z",
    fill: "#F68E1A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1981 6.56639H18.8555C18.1173 6.56533 17.4097 6.27516 16.8878 5.75953C16.366 5.24389 16.0725 4.54488 16.0718 3.81584V0L22.1981 6.56639Z",
    fill: "#F68E1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8319 22.7471H7.95152C6.75411 22.7471 5.78345 23.7057 5.78345 24.8883V29.8588C5.78345 31.0414 6.75411 32 7.95152 32H24.8319C26.0293 32 27 31.0414 27 29.8588V24.8883C27 23.7057 26.0293 22.7471 24.8319 22.7471Z",
    fill: "#F68E1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0117 28.4492V29.4185H12.9951V28.4492H14.0117Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0385 28.6867H15.5157L15.2632 29.4187H14.2305L15.7155 25.4375H16.8468L18.3318 29.4187H17.2869L17.0385 28.6867ZM16.7847 27.9494L16.2798 26.4748L15.7695 27.9494H16.7847Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6965 25.4097V29.4188H18.7151V25.4097H19.6965Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2696 15.21C10.2624 15.152 10.2687 15.0931 10.2882 15.0379C10.3076 14.9826 10.3395 14.9325 10.3816 14.8914C10.4185 14.8549 10.4623 14.826 10.5105 14.8063C10.5586 14.7866 10.6103 14.7764 10.6624 14.7764C10.7146 14.7764 10.7662 14.7866 10.8144 14.8063C10.8626 14.826 10.9064 14.8549 10.9432 14.8914C10.9801 14.9278 11.0094 14.971 11.0294 15.0186C11.0493 15.0662 11.0596 15.1172 11.0596 15.1687C11.0596 15.2202 11.0493 15.2712 11.0294 15.3188C11.0094 15.3664 10.9801 15.4096 10.9432 15.446C10.9016 15.4876 10.8509 15.5192 10.7949 15.5384C10.739 15.5576 10.6793 15.5638 10.6206 15.5567L6.00899 20.1112L12.894 16.778C12.894 16.778 13.6675 13.9328 14.545 13.0648L12.79 11.3315C11.9112 12.1982 9.03027 12.9621 9.03027 12.9621L5.65527 19.7619L10.2696 15.21Z",
    fill: "#F68E1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5401 12.0535L13.8167 9.36377L12.4812 10.6827L15.2046 13.3724L16.5401 12.0535Z",
    fill: "#F68E1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeAi);
export default __webpack_public_path__ + "static/media/Type=AI.9ed64fe7286a643f9b1ead90262c1077.svg";
export { ForwardRef as ReactComponent };